import { render, staticRenderFns } from "./InfoGeneral.vue?vue&type=template&id=3f3a1032&scoped=true&"
import script from "./InfoGeneral.vue?vue&type=script&lang=js&"
export * from "./InfoGeneral.vue?vue&type=script&lang=js&"
import style0 from "./InfoGeneral.vue?vue&type=style&index=0&id=3f3a1032&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3a1032",
  null
  
)

export default component.exports